import { ApplicationStatusUI } from '~domains/commerce/transactions/entities/application';

import { PosInfo } from '~platform/entities/pos';

import { DateTime } from '~shared/ui/date-time';
import { MoneyPh } from '~shared/ui/money-ph';

import { createColumnHelper } from '@tanstack/react-table';

import type { ApplicationsTableData } from '../model/applications-table-data';

export enum ColumnId {
  AGREEMENT_ID = 'agreementId',
  STATUS = 'status',
  DATE = 'date',
  POS = 'pos',
  SALE_AMOUNT = 'saleAmount',
  DOWN_PAYMENT = 'downPaymentAmount',
  FINANCED_AMOUNT = 'financedAmount',
}

type ColumnOption = { id: ColumnId; label: string };

export const COLUMN_OPTIONS: ColumnOption[] = [
  { id: ColumnId.AGREEMENT_ID, label: 'Agreement ID' },
  { id: ColumnId.STATUS, label: 'Status' },
  { id: ColumnId.DATE, label: 'Date & time' },
  { id: ColumnId.POS, label: 'Store name & address' },
  { id: ColumnId.SALE_AMOUNT, label: 'Sale amount' },
  { id: ColumnId.DOWN_PAYMENT, label: 'Down payment' },
  { id: ColumnId.FINANCED_AMOUNT, label: 'Financed amount' },
];

export const ALL_COLUMN_IDS = COLUMN_OPTIONS.map((option) => option.id);

export const SORT_OPTIONS: ColumnOption[] = COLUMN_OPTIONS.filter(
  (option) => option.id !== ColumnId.POS
);

const columnHelper = createColumnHelper<ApplicationsTableData>();

export const columns = [
  columnHelper.accessor((row) => row.agreementId, {
    id: ColumnId.AGREEMENT_ID,
    meta: { minWidth: 120, width: '15%', sortable: true },
    cell: (data) => data.getValue(),
    header: () => <>Agreement&nbsp;ID</>,
  }),
  columnHelper.accessor((row) => row.applicationStatus, {
    id: ColumnId.STATUS,
    meta: { minWidth: 120, sortable: true },
    cell: (data) => <ApplicationStatusUI status={data.getValue()} />,
    header: 'Status',
  }),
  columnHelper.accessor((row) => row.applicationTimestampUTC, {
    id: ColumnId.DATE,
    meta: { minWidth: 120, width: '14%', sortable: true },
    cell: (data) => <DateTime dateUTC={data.getValue()} />,
    header: () => <>Date&nbsp;&&nbsp;time</>,
  }),
  columnHelper.accessor((row) => row.pos, {
    id: ColumnId.POS,
    meta: { minWidth: 190, width: '28%' },
    cell: (data) => <PosInfo {...data.getValue()} />,
    header: () => <>Store name&nbsp;&&nbsp;address</>,
  }),
  columnHelper.accessor((row) => row.saleAmount, {
    id: ColumnId.SALE_AMOUNT,
    meta: { minWidth: 110, align: 'right', sortable: true },
    cell: (data) => <MoneyPh value={data.getValue()} />,
    header: () => <>Sale amount</>,
  }),
  columnHelper.accessor((row) => row.downPaymentAmount, {
    id: ColumnId.DOWN_PAYMENT,
    meta: { minWidth: 110, align: 'right', sortable: true },
    cell: (data) => <MoneyPh value={data.getValue()} />,
    header: () => <>Down payment</>,
  }),
  columnHelper.accessor((row) => row.financedAmount, {
    id: ColumnId.FINANCED_AMOUNT,
    meta: { minWidth: 110, align: 'right', sortable: true },
    cell: (data) => <MoneyPh value={data.getValue()} />,
    header: () => <>Financed amount</>,
  }),
];
